import { CompleteProfileDto, CreateProfileDto, CreateProfileResponseDto, ProfileDto, UpdateProfileDto } from '@/types/webapi';

export const IProfileApiId = Symbol.for('IProfileApi');

export interface IProfileApi {
    /**
     * Gets the current user's profile
     */
    getProfile(): Promise<ProfileDto>;

    /**
     * Registers a new profile
     */
    registerProfile(createProfile: CreateProfileDto): Promise<CreateProfileResponseDto>;

    /**
     * Updates the current user's profile: firstname, lastname or phone
     * @param updateProfile
     */
    updateProfile(updateProfile: UpdateProfileDto): Promise<ProfileDto>;

    /**
     * Completes the current user's profile: when not existing in Fort, need to pass in firstname and lastname
     * @param completeProfile
     */
    completeProfile(completeProfile: CompleteProfileDto): Promise<CreateProfileResponseDto>;

    /**
     * Updates email in current user's profile
     * @param email
     */
    updateEmail(email: { email: string }): Promise<void>;

    /**
     * Update password in current user's profile
     * @param password & passwordConfirm
     */
    updatePassword(password: { password: string; passwordConfirm: string; existingPassword: string }): Promise<void>;

    /**
     * Update two factor in current user's profile
     * @param twoFactorEnabled
     */
    updateTwoFactor(twoFactorEnabled: boolean): Promise<ProfileDto>;

    /**
     * Delete profile
     */
    deleteProfile(): Promise<void>;
}
